<script lang="ts">
	import type { Market } from '$lib/types/market';

	let { market } = $props<{
		market?: Market;
	}>();
</script>

<div class="page-footer">
	<div class="page-footer-content">
		{#if market?.formattedFooter}
			{@html market.formattedFooter}
		{/if}
		<p>
			<center>
				This market is using the <a href="http://www.locallygrown.net" target="_blank"
					>Locally Grown</a
				>
				online farmers market system. More information about how your market or farm can also use this
				system can be found at
				<a href="http://locallygrown.net/faq/" target="_blank">locallygrown.net/faq</a>. Legal
				information about using this website can be found at
				<a href="http://locallygrown.net/legal/index" target="_blank">locallygrown.net/legal</a>.
			</center>
		</p>
	</div>
</div>

<style>
	.page-footer {
		background: var(--lg-bg-secondary);
		border-top: 1px solid var(--lg-border-secondary);
		padding: 2rem 0;
		margin-top: 3rem;
	}

	.page-footer-content {
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 var(--lg-space-6);
		text-align: center;
		color: var(--lg-text-secondary);
	}

	.page-footer-content :global(img) {
		display: initial;
	}

	.page-footer-content :global(p) {
		margin-bottom: 1rem;
		line-height: 1.6;
	}

	.page-footer-content :global(a) {
		color: var(--lg-primary);
		text-decoration: none;
		font-weight: 500;
		transition: color 0.2s;
	}

	.page-footer-content :global(a:hover) {
		color: var(--lg-primary-hover);
		text-decoration: underline;
	}

	/* Legacy center tag support */
	.page-footer-content :global(center) {
		display: block;
		text-align: center;
	}

	@media (max-width: 768px) {
		.page-footer {
			padding: 1.5rem 0;
			margin-top: 2rem;
		}

		.page-footer-content {
			padding: 0 var(--lg-space-4);
		}
	}
</style>
